<template>
    <div id="loading-bg">
      <div class="loading-logo">
        <img src="@/assets/images/logo/logo.png" alt="Logo">
      </div>
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
</template>

<script>
export default {
    methods: {
        handleLoginEvent(data) {
            this.$store.dispatch('auth/updateAuthenticatedUserToken', { accessToken: data.accessToken })
            this.$router.push(data.target || "/");
        }
    },
    created() {
        this.$auth.handleAuthentication();
        this.$router.push('/');
    }
};
</script>

<style lang="scss">
@import "../assets/css/loader.css"
</style>
